import { useState, useEffect } from 'react';
import Breadcrumb from '@/components/base/Breadcrumb';
import { categories } from '@/mocks/categories';

export default function Categories() {
  const [activeCategory, setActiveCategory] = useState(categories[0].id);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const currentCategory = categories.find((c) => c.id === activeCategory) || categories[0];

  return (
    <div className="flex flex-col min-h-screen">
      <main>
        <section className="pt-24 pb-10 md:pt-32 md:pb-14 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-6">
              <Breadcrumb items={[
                { label: '首页', path: '/' },
                { label: '服务分类' },
              ]} />
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
              服务分类
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl font-body">
              深入了解btbxx各服务领域，找到最适合您企业需求的解决方案
            </p>
          </div>
        </section>

        <section className="py-8 bg-background-50 border-b border-background-200/60 sticky top-16 z-30">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-2 overflow-x-auto pb-1 flex-wrap">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => {
                    setActiveCategory(cat.id);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-label font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    activeCategory === cat.id
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.name}
                </button>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <div className="flex items-center gap-3 mb-8">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className={`${currentCategory.icon} text-2xl`}></i>
                  </div>
                  <div>
                    <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                      {currentCategory.name}
                    </h2>
                  </div>
                </div>

                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 font-body">
                  {currentCategory.description}
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  {currentCategory.features.map((feature) => (
                    <div
                      key={feature.name}
                      className="bg-background-50 rounded-lg p-6 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 group"
                    >
                      <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                        {feature.name}
                      </h3>
                      <p className="text-sm text-foreground-600 leading-relaxed font-body">
                        {feature.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              <aside className="lg:col-span-1">
                <div className="bg-background-100 rounded-lg p-6 border border-background-200/60 sticky top-36">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-4">
                    快速导航
                  </h3>
                  <div className="space-y-1">
                    {categories.map((cat) => (
                      <button
                        key={cat.id}
                        onClick={() => {
                          setActiveCategory(cat.id);
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                        className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-label font-medium transition-all duration-200 text-left cursor-pointer ${
                          activeCategory === cat.id
                            ? 'bg-primary-100 text-primary-700'
                            : 'text-foreground-700 hover:bg-background-200'
                        }`}
                      >
                        <i className={`${cat.icon} text-base`}></i>
                        {cat.name}
                      </button>
                    ))}
                  </div>

                  <div className="mt-6 pt-6 border-t border-background-200/60">
                    <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-3">
                      需要定制化方案？
                    </h3>
                    <p className="text-xs text-foreground-600 mb-4 font-body">
                      联系我们的顾问团队，为您量身定制专属解决方案
                    </p>
                    <a
                      href="/about"
                      className="block w-full text-center px-4 py-2.5 rounded-md text-sm font-label font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      联系我们
                    </a>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-label font-medium tracking-wide mb-3">
                更多服务
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                探索其他服务领域
              </h2>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => {
                    setActiveCategory(cat.id);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className={`flex flex-col items-center gap-3 p-5 rounded-lg border transition-all duration-200 cursor-pointer ${
                    activeCategory === cat.id
                      ? 'bg-primary-50 border-primary-200'
                      : 'bg-background-50 border-background-200/60 hover:border-accent-200/60'
                  }`}
                >
                  <div className={`w-12 h-12 flex items-center justify-center rounded-lg transition-colors duration-200 ${
                    activeCategory === cat.id
                      ? 'bg-primary-100 text-primary-600'
                      : 'bg-accent-100 text-accent-600'
                  }`}>
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <span className="text-xs font-label font-medium text-foreground-700 whitespace-nowrap">
                    {cat.name}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </section>
      </main>

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'btbxx服务分类',
        description: '深入了解btbxx各服务领域：企业解决方案、技术平台、营销增长、客户服务、数据智能、电商服务。找到最适合您企业需求的数字化解决方案。',
        url: 'https://www.btbxx.com/categories',
        isPartOf: { '@type': 'WebSite', name: 'btbxx', url: 'https://www.btbxx.com/' },
      })}</script>
    </div>
  );
}